import React, { useCallback, useMemo, useState } from "react";
import { getMaintenanceReportsAPI } from "utils/api";
import { defaultNgiErrorMethod, warnMessage } from "components/Common/responses/message";
import { Col, Container } from "reactstrap";
import NGITable from "components/Common/NGITable";
import ReportsFilter from "./reportsFilter";
import { reportsListColumns } from "pages/meter-management/meters/meterDetails/Tabs/historyTab/listColumns";
import MarkAsFaultyReportModal from "pages/meter-management/ready-for-repair/MarkAsFaultyReportModal";
import { getEditableItems } from "pages/meter-management/ready-for-repair/RepairMeter/utils";
import { AUTH_USER, USER_ROLES } from "utils/constants";
import { useSelector } from "react-redux";
import { DictionariesSelector } from "store/dictionaries/selectors";

const HistoryTab = ({ data }) => {
  const [isLoading, setLoader] = useState(false);
  const [reportsList, setReportsList] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});
  const [reportItem, setReportItem] = useState(null);
  const hideRoles = [USER_ROLES.INTERNAL_AUDITOR, USER_ROLES.METER_ENGINEER];

  const {
    list: { meterFaultReasonsRepair, meterFaultReasonsTesting },
  } = useSelector(DictionariesSelector);

  const openFaultyModal = useCallback(id => setReportItem(id), []);

  const closeFaultyModal = useCallback(() => setReportItem(null), []);

  const handleFilter = useCallback(
    (newFilterOptions = { meterId: data?.id }) => {
      setLoader(true);
      getMaintenanceReportsAPI({
        ...newFilterOptions,
        meterId: data?.id,
      })
        .then(async res => {
          const {
            result: { items },
          } = res?.data;
          setLoader(false);
          if (items === 0) {
            warnMessage("No reports were found");
          }
          setReportsList(res?.data || null);
        })
        .catch(err => {
          setLoader(false);
          setReportsList(null);
          defaultNgiErrorMethod(err);
        });
    },
    [filterOptions, data?.id]
  );

  const handleListUpdate = useCallback(() => onFiltering(filterOptions), []);

  const onFiltering = useCallback(options => {
    setFilterOptions(options);
    handleFilter(options);
  }, []);

  const columns = useMemo(() => {
    const col = reportsListColumns(openFaultyModal);
    if (hideRoles?.includes(AUTH_USER()?.roles)) col.pop();
    return col;
  }, [openFaultyModal]);

  return (
    <Container fluid>
      <div className="filters-wrapper">
        <ReportsFilter handleFilter={onFiltering} isLoading={isLoading} />
      </div>
      <Col lg={12}>
        <NGITable
          isLoading={isLoading}
          columns={columns}
          data={getEditableItems(reportsList, data)}
          updateList={getEditableItems(reportsList, data)}
        />
      </Col>
      {!!reportItem && (
        <MarkAsFaultyReportModal
          isLoading={isLoading}
          activeItem={reportItem?.id}
          reasons={reportItem.type === "Testing" ? meterFaultReasonsTesting : meterFaultReasonsRepair}
          onClose={closeFaultyModal}
          updateReportsList={handleListUpdate}
          data={data}
        />
      )}
    </Container>
  );
};

export default HistoryTab;
